import variables from "./config";

function CTA() {
  const buttons = [];

  // Butonları array'e ekle
  if (variables.mail?.link) {
    buttons.push(
      <a href={variables.mail.link} className="cta-btn" id="email" key="email">
        <div className="cta-btn-icon">
          <box-icon name="envelope" color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Email</span>
      </a>
    );
  }

  if (variables.tel?.link) {
    buttons.push(
      <a
        href={variables.tel.link}
        className="cta-btn"
        id="telephone"
        key="telephone"
      >
        <div className="cta-btn-icon">
          <box-icon name="phone" color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Phone</span>
      </a>
    );
  }

  if (variables.instagram?.link) {
    buttons.push(
      <a
        href={variables.instagram.link}
        className="cta-btn"
        id="instagram"
        key="instagram"
      >
        <div className="cta-btn-icon">
          <box-icon name="instagram" type="logo" color="#eee"></box-icon> 
        </div>
        <span className="cta-btn-text">Instagram</span>
      </a>
    );
  }

  if (variables.facebook?.link) {
    buttons.push(
      <a
        href={variables.facebook.link}
        className="cta-btn"
        id="facebook"
        key="facebook"
      >
        <div className="cta-btn-icon">
          <box-icon name="facebook" type="logo" color="#eee"></box-icon> 
        </div>
        <span className="cta-btn-text">Facebook</span>
      </a>
    );
  }

  if (variables.fmessenger?.link) {
    buttons.push(
      <a

        href={variables.fmessenger.link}
        className="cta-btn"
        id="messenger"
        key="messenger"
      >
        <div className="cta-btn-icon">
          <box-icon name="messenger" type="logo" color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Messenger</span>
      </a>
    );
  }

  if (variables.whatsapp?.link) {
    buttons.push(
      <a
        href={variables.whatsapp.link}
        className="cta-btn"
        id="whatsapp"
        key="whatsapp"
      >
        <div className="cta-btn-icon">
         <box-icon name="whatsapp" type="logo" color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Whatsapp</span>
      </a>
    );
  }

  if (variables.behance?.link) {
    buttons.push(
      <a
        href={variables.behance.link}
        className="cta-btn"
        id="behance"
        key="behance"
      >
        <div className="cta-btn-icon">
         <box-icon name="behance" type="logo" color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Behance</span>
      </a>
    );
  }

  if (variables.greviews?.link) {
    buttons.push(
      <a
        href={variables.greviews.link}
        className="cta-btn"
        id="greviews"
        key="greviews"
      >
        <div className="cta-btn-icon">
         <box-icon type="logo" name="google" color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Google Reviews</span>
      </a>
    );
  }

  if (variables.gmaps?.link) {
    buttons.push(
      <a
        href={variables.gmaps.link}
        className="cta-btn"
        id="gmaps"
        key="gmaps"
      >
        <div className="cta-btn-icon">
         <box-icon type='solid' name='location-plus' color="#eee"></box-icon>
        </div>
        <span className="cta-btn-text">Google Maps</span>
      </a>
    );
  }

  if (variables.linkedin?.link) {
    buttons.push(
      <a
        href={variables.linkedin.link}
        className="cta-btn"
        id="linkedin"
        key="linkedin"
      >
        <div className="cta-btn-icon">
         <box-icon name="linkedin" type="logo"></box-icon>
        </div>
        <span className="cta-btn-text">LinkedIn</span>
      </a>
    );
  }

  // Tek veya çift sayıya göre hizalama
  const isOdd = buttons.length % 2 !== 0;

  return (
    <div className={`cta ${isOdd ? "single-column" : "double-column"}`}>
      {isOdd
        ? buttons.map((button) => (
            <div className="button-group" key={button.key}>
              {button}
            </div>
          ))
        : buttons
            .reduce((rows, button, index) => {
              if (index % 2 === 0) {
                rows.push([button]);
              } else {
                rows[rows.length - 1].push(button);
              }
              return rows;
            }, [])
            .map((row, index) => (
              <div className="button-group" key={index}>
                {row}
              </div>
            ))}
    </div>
  );
}

export default CTA;
